
export const VEHICLES_INFORMATION = [
  {
    brand: "ALTIGREEN",
    model: "NeEV",
    vehicle_name: "ALTIGREEN NeEV",
    registration_year: "Unknown",
    registration_number: "KA05AL5644",
    kms_run: "1,000",
    price: "3,200",
    emi: "1,200",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 1,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Bangalore",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  },
  {
    brand: "PIAGGIO",
    model: "Ape E-xtra fx",
    vehicle_name: "PIAGGIO Ape E-xtra fx",
    registration_year: "Unknown",
    kms_run: "3,500",
    price: "40,100",
    emi: "2,500",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 1,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Mumbai",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  },
  {
    brand: "PIAGGIO",
    model: "Ape E-xtra fx",
    vehicle_name: "PIAGGIO Ape E-xtra fx",
    registration_year: "Unknown",
    kms_run: "2,800",
    price: "40,700",
    emi: "3,000",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 0,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Chennai",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  },
  {
    brand: "PIAGGIO",
    model: "Ape E-xtra fx",
    vehicle_name: "PIAGGIO Ape E-xtra fx",
    registration_year: "Unknown",
    kms_run: "4,200",
    price: "40,100",
    emi: "2,800",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 1,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Hyderabad",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  },
  {
    brand: "EULER",
    model: "Hiload",
    vehicle_name: "EULER Hiload",
    registration_year: "Unknown",
    kms_run: "3,700",
    price: "0",
    emi: "1,500",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 1,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Delhi",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  },
  {
    brand: "MAHINDRA",
    model: "TREO ZOR",
    vehicle_name: "MAHINDRA TREO ZOR",
    registration_year: "Unknown",
    kms_run: "2,100",
    price: "2,600",
    emi: "1,800",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 1,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Pune",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  },
  {
    brand: "PIAGGIO",
    model: "Ape E-xtra fx",
    vehicle_name: "PIAGGIO Ape E-xtra fx",
    registration_year: "Unknown",
    kms_run: "1,600",
    price: "8,100",
    emi: "2,200",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 1,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Ahmedabad",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  },
  {
    brand: "ALTIGREEN",
    model: "NeEV HDX",
    vehicle_name: "ALTIGREEN NeEV HDX",
    registration_year: "Unknown",
    kms_run: "5,000",
    price: "1,100",
    emi: "900",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 1,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Kolkata",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  },
  {
    brand: "PIAGGIO",
    model: "Ape E-xtra fx",
    vehicle_name: "PIAGGIO Ape E-xtra fx",
    registration_year: "Unknown",
    kms_run: "2,300",
    price: "1,100",
    emi: "1,000",
    battery_condition: "Unknown",
    tag: "5% OFF This November",
    inStock: 1,
    image_url: "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg",
    city: "Jaipur",
    vehicle_images: [
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img1.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img2.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img3.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img4.jpeg",
      "https://assets.turnoclub.com/developer/innovolt/KA05AL5644/img5.jpeg"
    ]
  }
];

export const  VEHICLES_DATA = [
  //Thane
  {
  id: 100001,  
  brand: "MAHINDRA",
  model: "Zor Grand DV+",
  vehicle_name: "MAHINDRA Zor Grand DV+",
  registration_year: " 25-Jul-2023",
  registration_number: "MH04KX6420",
  kms_run: "2895",
  price: "376,552.50",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Thane",
  images_list: [
    "img1.jpeg",
    "img2.jpeg",
    "img3.jpeg",
    "img4.jpeg",
    "img5.jpeg"
  ]
},
{
  id: 100002,
  brand: "EULER",
  model: "Hiload",
  vehicle_name: "EULER Hiload",
  registration_year: "29-Feb-2024",
  registration_number: "MH48CX0765",
  kms_run: "321",
  price: "424,079.50",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Thane",
  images_list: [
    "img1.jpeg",
    "img2.jpeg",
    "img3.jpeg",
    "img4.jpeg",
    "img5.jpeg"
  ]
},
{
  id: 100003,
  brand: "PIAGGIO",
  model: "Ape E-xtra fx Max",
  vehicle_name: "PIAGGIO Ape E-xtra fx Max",
  registration_year: "23-Jan-2023",
  registration_number: "MH43CA4033",
  kms_run: "1817",
  price: "330,185.77",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Thane",
},

//Pune
{
  id: 100004,
  brand: "ALTIGREEN",
  model: "NeEV",
  vehicle_name: "ALTIGREEN NeEV",
  registration_year: "17-Apr-2023",
  registration_number: "MH10CQ3215",
  kms_run: "3206",
  price: "433,494.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Pune",
},
{ 
  id: 100005,
  brand: "PIAGGIO",
  model: "Ape E-xtra fx",
  vehicle_name: "PIAGGIO Ape E-xtra fx",
  registration_year: "13-Dec-2023",
  registration_number: "MH12VW4805",
  kms_run: "61",
  price: "391,944.50",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Pune",
},
{
  id: 100006,
  brand: "PIAGGIO",
  model: "Ape E-xtra fx Max",
  vehicle_name: "PIAGGIO Ape E-xtra fx Max",
  registration_year: "4-Sep-2023",
  registration_number: "MH14KU2909",
  kms_run: "51",
  price: "399,130.08",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Pune",
},
{
  id: 100007,
  brand: "PIAGGIO",
  model: "Ape E-xtra fx Max",
  vehicle_name: "PIAGGIO Ape E-xtra fx Max",
  registration_year: "29-Aug-2023",
  registration_number: "MH10CQ3215",
  kms_run: "67",
  price: "399,122.08",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Pune",
},

//Lucknow
{
  id: 100008,
  brand: "MAHINDRA",
  model: "TREO PLUS SFT SM",
  vehicle_name: " MAHINDRA TREO PLUS SFT SM",
  registration_year: "29-Jul-2024",
  registration_number: "UP32XN1108",
  kms_run: " 11655",
  price: "350000",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Lucknow",
},
{
  id: 100009,
  brand: "MONTRA",
  model: "ePV 2.0",
  vehicle_name: "MONTRA ePV 2.0",
  registration_year: "22-Jul-2024",
  registration_number: "UP32XN0116",
  kms_run: "10454",
  price: "412,120.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Lucknow",
},
{
  id: 100010,
  brand: "MAHINDRA",
  model: "TREO PLUS SFT SM",
  vehicle_name: "MAHINDRA TREO PLUS SFT SM",
  registration_year: "6-Oct-2024",
  registration_number: "UP32XN7319",
  kms_run: "6001",
  price: "329,819.50",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Lucknow",
},
{
  id: 100011,
  brand: "MAHINDRA",
  model: "TREO PLUS SFT SM",
  vehicle_name: "MAHINDRA NeTREO PLUS SFT SMEV",
  registration_year: "20-Jun-2024",
  registration_number: "UP32WN7620",
  kms_run: "10949",
  price: "374,454.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Lucknow",
},
//Hyderabad
{
  id: 100012,
  brand: "E-TRIO",
  model: " Touro Max++",
  vehicle_name: "E-TRIO Touro Max++",
  registration_year: "21-Mar-2023",
  registration_number: "TS07UM2765",
  kms_run: "nill",
  price: "329,600.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Hyderabad",
},
{
  id: 100013,
  brand: "MAHINDRA",
  model: "TREO ZOR",
  vehicle_name: "MAHINDRA TREO ZOR",
  registration_year: "4-Feb-2023",
  registration_number: "TS30TA4819",
  kms_run: "3206",
  price: "330,311.84",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Hyderabad",
},
{
  id: 100014,
  brand: "PIAGGIO",
  model: "Ape E-xtra fx",
  vehicle_name: "PIAGGIO Ape E-xtra fx",
  registration_year: "3-Mar-2023",
  registration_number: "TS12UD9598",
  kms_run: "18269",
  price: "363,310.50",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Hyderabad",
},
{
  id: 100015,
  brand: "PIAGGIO",
  model: "Ape E-xtra fx",
  vehicle_name: "PIAGGIO Ape E-xtra fx",
  registration_year: "21-Oct-2022",
  registration_number: "TS08UJ8573",
  kms_run: "2345",
  price: "316,972.50",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Hyderabad",
},

//Delhi
{
  id: 100016,
  brand: "ALTIGREEN",
  model: "NeEV HDX",
  vehicle_name: "ALTIGREEN NeEV HDX",
  registration_year: "26-Dec-2023",
  registration_number: "DL51EV3613",
  kms_run: "19423",
  price: "2,40,000",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Delhi",
},
{
  id: 100017,
  brand: "EULER",
  model: "Hiload",
  vehicle_name: "EULER Hiload",
  registration_year: "9-Mar-2023",
  registration_number: "DL51GD7311",
  kms_run: "20856",
  price: "328,987.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Delhi",
},
{
  id: 100018,
  brand: "ALTIGREEN",
  model: "NeEV HDX",
  vehicle_name: "ALTIGREEN NeEV HDX",
  registration_year: "27-Oct-2023",
  registration_number: "DL51EV2083",
  kms_run: "29607",
  price: "345,486.50",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Delhi",
},
{
  id: 100019,
  brand: "EULER",
  model: "NeEV HDX",
  vehicle_name: "EULER NeEV HDX",
  registration_year: "31-Aug-2023",
  registration_number: "DL51EV0882",
  kms_run: "43510",
  price: "331,505.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Delhi",
},

//Bangalore
{
  id: 100020,
  brand: "MAHINDRA",
  model: "TREO ZOR",
  vehicle_name: "MAHINDRA TREO ZOR",
  registration_year: "9-Jan-2023",
  registration_number: "KA22AA1269",
  kms_run: " 1111",
  price: "321,426.63",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpeg",
  city: "Bangalore",
},
{
  id: 100021,
  brand: "PIAGGIO",
  model: "Ape E-xtra fx Max",
  vehicle_name: "PIAGGIO Ape E-xtra fx Max",
  registration_year: "22-Aug-2023",
  registration_number: "KA05AM7436",
  kms_run: "26362",
  price: "342,358.84",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Bangalore",
},
{
  id: 100022,
  brand: "PIAGGIO",
  model: "Ape E-xtra fx Max",
  vehicle_name: "PIAGGIO Ape E-xtra fx Max",
  registration_year: "22-Aug-2023",
  registration_number: "KA05AM7544",
  kms_run: "20270",
  price: "345,404.84",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Bangalore",
},
{
  id: 100023,
  brand: "MONTRA",
  model: "ePV 2.0",
  vehicle_name: "MONTRA ePV 2.0",
  registration_year: "3-Jul-2024",
  registration_number: "KA02AK4976",
  kms_run: "13842",
  price: "403,124.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Bangalore",
},
//Kanpur
{
  id: 100024,
  brand: "MONTRA",
  model: "ePV 2.0",
  vehicle_name: "MONTRA ePV 2.0",
  registration_year: "31-Aug-2024",
  registration_number: "UP78KN4849",
  kms_run: "15560",
  price: "350,244.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Kanpur",
},
{
  id: 100025,
  brand: "PIAGGIO",
  model: "Ape E-CITY FX NE MAX",
  vehicle_name: "PIAGGIO Ape E-CITY FX NE MAX",
  registration_year: "7-May-2024",
  registration_number: "UP78JT8697",
  kms_run: "28203",
  price: "423,159.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Kanpur",
},
{
  id: 100026,
  brand: "GREAVES",
  model: "ELTRA",
  vehicle_name: "GREAVES ELTRA",
  registration_year: "15-Jun-2024",
  registration_number: "UP78KN0932",
  kms_run: "20378",
  price: "359,115.00",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Kanpur",
},

//Chennai
{
  id: 100027,
  brand: "EULER",
  model: "Hiload DVXR13",
  vehicle_name: "EULER Hiload DVXR13",
  registration_year: "27-Jun-2023",
  registration_number: "TN18BM2931",
  kms_run: "17591",
  price: "333,919.50",
  emi: "1,200", 
  battery_condition: "Unknown",
  tag: "5% OFF This Year",
  inStock: 1,
  image_url: "img1.jpg",
  city: "Chennai",
},
]

